import type React from 'react';

import Typography from '../../Typography';

export interface StatsSeparatorProps {
  children?: React.ReactNode;
  className?: string;
}

const StatsSeparator = ({ children, className }: StatsSeparatorProps) => {
  if (children) return children;
  return (
    <div className={className}>
      <Typography variant='input-text'>•</Typography>
    </div>
  );
};

StatsSeparator.displayName = 'Stats.StatsSeparator';

export default StatsSeparator;
